export enum TeilpaketStatus {
  NEU_KONVERTIERT = "neu/konvertiert",
  BEARBEITET = "bearbeitet",
  GEPRUEFT_OK = "geprüft/ok",
  GEPRUEFT_NICHT_OK = "geprüft/nicht ok",
  IN_FREIGABE = "in Freigabe",
  FREIGEGEBEN = "freigegeben",
  NICHT_EINGESPIELT = "nicht eingespielt",
  EINGESPIELT = "eingespielt",
  ABGELEHNT = "abgelehnt",
  UNGUELTIG = "ungültig"
}
